import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { KirjausehdotusPalauteLahetysPyynto, KirjausehdotusPalauteLahetysVastaus } from '../../_jaettu-lemonator/model/llm-kirjausehdotus-palaute'

export function lahetaKirjausehdotusPalaute(firebase: FirebaseLemonator, pyynto: KirjausehdotusPalauteLahetysPyynto): Promise<KirjausehdotusPalauteLahetysVastaus> {
  return firebase.functionsCall<KirjausehdotusPalauteLahetysPyynto, KirjausehdotusPalauteLahetysVastaus>('llmKirjausehdotusPalauteLaheta', pyynto)
}
